<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-card class="overflow-hidden">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <customer-autocomplete-filter
                  :fatherEditedCustomer="filterNotWork"
                  :editedCustomerIndex="-1"
                  :customerName="'quotation_customer_number'"
                  @setFilterCustomer="setNotWorkFilterCustomer"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-text-field
                  :label="$t('quotation_license_plate')"
                  v-model="filterNotWork.LicensePlate"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-autocomplete
                  :items="zoneList"
                  item-text="Name"
                  item-value="Type"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                  :label="$t('fix_zone')"
                  v-model="filterNotWork.ZoneType"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-autocomplete
                  :items="mixNoticeFixTypeList"
                  item-text="Name"
                  item-value="Type"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                  :label="$t('engineer_mix_type')"
                  v-model="filterNotWork.MixNoticeFixType"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-autocomplete
                  :items="allSpecialNeedList"
                  item-text="Name"
                  item-value="Id"
                  :label="$t('quotation_special_need')"
                  v-model="filterNotWork.SpecialNeedId"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <date-picker
                  :dateName="'engineer_start_time'"
                  :isAllTextFieldDisabled="false"
                  @setDate="setStartNotWorkTime"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <date-picker
                  :dateName="'engineer_end_time'"
                  :isAllTextFieldDisabled="false"
                  @setDate="setEndNotWorkTime"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="getNotWork" color="primary">{{
              $t('quotation_item_new_install_search')
            }}</v-btn>
          </v-card-actions>
        </v-card>
        <v-data-table
          :headers="notWorkDataTableHeaders"
          :items="notWorkList"
          class="elevation-1 mt-5"
          :loading="isNotWorkLoading"
          :loading-text="$t('common_get_data')"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          :footer-props="{
            'items-per-page-options': [30, 50, 100],
            'items-per-page-text': $t('item_rows_per_page'),
          }"
          :header-props="headerProps"
          item-key="Id"
          show-select
          v-model="selected"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('engineer_tab_one_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="isWork" :disabled="selected.length === 0">
                批次派工
              </v-btn>
              <v-dialog v-model="isShowEditNotWorkDialog" fullscreen persistent>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('engineer_tab_one') }}</span>
                  </v-card-title>
                  <v-tabs>
                    <v-tab href="#tab-1">{{ $t('fix_tab_title') }}</v-tab>
                    <v-tab
                      href="#tab-2"
                      v-if="editedNotWork.FileNameList && editedNotWork.FileNameList.length > 0"
                      >{{ $t('fix_photo') }}</v-tab
                    >
                    <v-tab href="#tab-3" v-if="editedNotWork.NumberType === 6">{{
                      $t('quotation_tab_third')
                    }}</v-tab>
                    <v-tab-item value="tab-1">
                      <v-card flat>
                        <v-card-text>
                          <v-container>
                            <ValidationObserver ref="dialogEditedNotWork">
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-autocomplete
                                    :items="mixNoticeFixTypeList"
                                    item-text="Name"
                                    item-value="Type"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    :label="$t('engineer_mix_type')"
                                    v-model="editedNotWork.MixNoticeFixType"
                                    disabled
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.Number"
                                    :label="$t('engineer_number')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-autocomplete
                                    :items="allSpecialNeedList"
                                    item-text="Name"
                                    item-value="Name"
                                    :label="$t('quotation_special_need')"
                                    disabled
                                    v-model="editedNotWork.SpecialNeedList"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    small-chips
                                    multiple
                                    return-object
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.Brand"
                                    disabled
                                    label="廠牌/車型"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.CustomerNumber"
                                    :label="$t('quotation_customer_number')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.CustomerName"
                                    :label="$t('quotation_shortname')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.CustomerFullName"
                                    :label="$t('quotation_full_name')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.LicensePlate"
                                    :label="$t('quotation_license_plate')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-autocomplete
                                    :items="zoneList"
                                    item-text="Name"
                                    item-value="Type"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    :label="$t('fix_zone')"
                                    v-model="editedNotWork.ZoneType"
                                    disabled
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.CarPlace"
                                    :label="$t('quotation_car_place')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                                  {{ $t('engineer_first_contact') }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.FirstContactName"
                                    :label="$t('installation_notice_contact_name')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.FirstContactPhone"
                                    :label="$t('installation_notice_contact_name')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                                  {{ $t('engineer_second_contact') }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.SecondContactName"
                                    :label="$t('installation_notice_contact_name')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.SecondContactPhone"
                                    :label="$t('installation_notice_contact_name')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                                  {{ $t('engineer_third_contact') }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.ThirdContactName"
                                    :label="$t('installation_notice_contact_name')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.ThirdContactPhone"
                                    :label="$t('installation_notice_contact_name')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-autocomplete
                                    :items="maintenanceEngineers"
                                    item-text="NickName"
                                    item-value="UserName"
                                    :label="$t('installation_notice_engineer')"
                                    v-model="editedNotWork.MaintenanceEngineer"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    disabled
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.Point"
                                    :label="$t('installation_notice_point')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedNotWork.ElsePoint"
                                    :label="$t('installation_notice_else_point')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    :label="$t('installation_notice_else_point_reason')"
                                    v-model="editedNotWork.ElsePointReason"
                                    v-if="editedNotWork.ElsePoint != 0"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="
                                  editedNotWork.NumberType === 6 &&
                                    editedNotWork.MixNoticeFixType !== 4
                                "
                              >
                                <v-col>
                                  <v-textarea
                                    v-model="editedNotWork.FixReason"
                                    :label="$t('fix_reason')"
                                    disabled
                                    outlined
                                  ></v-textarea>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="4">
                                  <v-textarea
                                    outlined
                                    v-model="editedNotWork.Remark"
                                    :label="$t('fix_dispatch_remark')"
                                    disabled
                                    rows="2"
                                  ></v-textarea>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-textarea
                                    outlined
                                    v-model="editedNotWork.InternalRemark"
                                    :label="$t('fix_internal_remark')"
                                    disabled
                                    rows="2"
                                  ></v-textarea>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-textarea
                                    outlined
                                    v-model="editedNotWork.EngineerRemark"
                                    :label="$t('fix_engineer_remark')"
                                    disabled
                                    rows="2"
                                  ></v-textarea>
                                </v-col>
                              </v-row>
                            </ValidationObserver>
                          </v-container>
                        </v-card-text>
                        <v-data-table
                          :headers="notWorkItemDataTableHeaders"
                          :items="editedNotWork.NotWorkItems"
                          class="elevation-1 my-5 mx-5"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          :footer-props="{
                            'items-per-page-options': [30, 50, 100],
                            'items-per-page-text': $t('item_rows_per_page'),
                          }"
                          :header-props="headerProps"
                          v-if="
                            editedNotWork.MixNoticeFixType != 8 &&
                              editedNotWork.MixNoticeFixType != 9 &&
                              editedNotWork.MixNoticeFixType != 10
                          "
                        >
                          <template v-slot:[`item.InstallPosition`]="{ item }">
                            {{ turnData(item.InstallPosition) }}
                          </template>
                          <template v-slot:[`item.BuyOrRentType`]="{ item }">
                            {{ turnBuyOrRentType(item.BuyOrRentType) }}
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-row>
                        <v-col cols="2" v-for="fixImage in notWorkFixImageList" :key="fixImage">
                          <v-card flat>
                            <v-img :src="fixImage"></v-img>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                      <v-card flat>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedNotWork.TpAccount"
                                  label="環保帳號"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedNotWork.TpPassword"
                                  label="環保密碼"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeEditedNotWork">
                      {{ $t('common_cancel') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.Edit`]="{ item }">
            <v-btn icon @click="isShowEditNotWorkDialogBtn(item)">
              <v-icon small>
                mdi-eye
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.MixNoticeFixType`]="{ item }">
            {{ turnMixNoticeFixType(item.MixNoticeFixType) }}
          </template>
          <template v-slot:[`item.NumberType`]="{ item }">
            {{ turnNumberTypeName(item.NumberType) }}
          </template>
          <template v-slot:[`item.ZoneType`]="{ item }">
            {{ turnZoneTypeName(item.ZoneType) }}
          </template>
          <template v-slot:[`item.SpecialNeedList`]="{ item }">
            {{ turnSpecialNeedName(item.SpecialNeedList) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import DatePicker from '@/components/DatePicker.vue'
import { HttpEngineerWork, HttpFix, HttpInstallPosition } from '@/js/http-Manager'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { ZoneType } from '@/js/ZoneType'
import { MixNoticeFixType } from '@/js/MixNoticeFixType'
import { NumberType } from '@/js/NumberType'
import { BuyOrRentType } from '@/js/BuyOrRentType'
export default {
  components: { DatePicker, CustomerAutocompleteFilter },
  name: 'EngineerWorkNotWork',
  props: {
    maintenanceEngineers: {
      type: Array
    },
    allSpecialNeedList: {
      type: Array
    },
    headerProps: {
      type: Object
    },
    getUserAccountId: {
      type: String
    },
    tabTitle: {
      type: String
    }
  },
  data: () => ({
    isNotWorkLoading: false,
    notWorkList: [],
    filterNotWork: {
      LicensePlate: '',
      CustomerId: '',
      StartTime: 0,
      EndTime: 0,
      MixNoticeFixType: 0,
      zoneType: 0,
      SpecialNeedId: ''
    },
    zoneList: [],
    mixNoticeFixTypeList: [],
    editedNotWorkIndex: -1,
    editedNotWork: {
      NumberType: 0,
      MixNoticeFixType: 0,
      Number: '',
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FixReason: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      LicensePlate: '',
      OriginalLicensePlate: '',
      Point: 0,
      ElsePoint: 0,
      MaintenanceEngineer: '',
      IsWork: false,
      ZoneType: 0,
      FileNameList: [],
      NotWorkItems: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      Brand: '',
      Remark: '',
      InternalRemark: '',
      EngineerRemark: ''
    },
    defaultNotWork: {
      NumberType: 0,
      MixNoticeFixType: 0,
      Number: '',
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FixReason: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      LicensePlate: '',
      OriginalLicensePlate: '',
      Point: 0,
      ElsePoint: 0,
      MaintenanceEngineer: '',
      IsWork: false,
      ZoneType: 0,
      FileNameList: [],
      NotWorkItems: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      Brand: '',
      Remark: '',
      InternalRemark: '',
      EngineerRemark: ''
    },
    isShowEditNotWorkDialog: false,
    notWorkFixImageList: [],
    selected: [],
    installPositionList: []
  }),
  async mounted () {
    await this.getZoneType()
    await this.getMixNoticeFixType()
    await this.getNotWork()
    await this.getInstallPosition()
  },
  watch: {
    async tabTitle (val) {
      if (val === 'tab-1') {
        await this.getNotWork()
      }
    }
  },
  computed: {
    notWorkDataTableHeaders () {
      return [
        {
          text: this.$t('engineer_number_type'),
          align: 'start',
          value: 'NumberType',
          sortable: false
        },
        {
          text: this.$t('engineer_mix_type'),
          align: 'start',
          value: 'MixNoticeFixType',
          sortable: false
        },
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber',
          sortable: false
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'start',
          value: 'CustomerName',
          sortable: false
        },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('fix_zone'),
          align: 'start',
          value: 'ZoneType'
        },
        {
          text: this.$t('quotation_car_place'),
          align: 'start',
          value: 'CarPlace'
        },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        {
          text: this.$t('installation_notice_point'),
          align: 'start',
          value: 'Point'
        },
        { text: this.$t('installation_notice_else_point'), align: 'start', value: 'ElsePoint' },
        { text: this.$t('fix_reason'), align: 'start', value: 'FixReason' },
        {
          text: this.$t('common_look'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    notWorkItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'BomName'
        },
        {
          text: this.$t('quotation_item_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        {
          text: this.$t('quotation_item_quantity'),
          align: 'end',
          value: 'Quantity'
        },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber'
        },
        {
          text: this.$t('quotation_item_warranty_period'),
          align: 'end',
          value: 'WarrantyPeriod'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        }
      ]
    }
  },
  methods: {
    async getInstallPosition () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response.status === 200 ? response.data.Data : []
    },
    async setNotWorkFilterCustomer (val) {
      this.filterNotWork.CustomerId = val.Id
      this.filterNotWork = JSON.parse(JSON.stringify(this.filterNotWork))
    },
    async getZoneType () {
      let response = await HttpFix.GetZoneType()
      this.zoneList = response.status === 200 ? response.data.Data : []
    },
    async getMixNoticeFixType () {
      let response = await HttpEngineerWork.GetMixNoticeFixType()
      this.mixNoticeFixTypeList = response.status === 200 ? response.data.Data : []
    },
    setStartNotWorkTime (val) {
      this.filterNotWork.StartTime = val * 1
    },
    setEndNotWorkTime (val) {
      this.filterNotWork.EndTime = val * 1
    },
    turnData (value) {
      return ItemInstallPositionType.getFormInstallPositionTypeName(value, this.installPositionList)
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    turnMixNoticeFixType (val) {
      return MixNoticeFixType.MixNoticeFixTypeName(val)
    },
    turnZoneTypeName (val) {
      return ZoneType.ZoneTypeName(val)
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    turnNumberTypeName (val) {
      return NumberType.NumberTypeName(val)
    },
    async isShowEditNotWorkDialogBtn (item) {
      this.editedNotWorkIndex = this.notWorkList.indexOf(item)
      this.editedNotWork = JSON.parse(JSON.stringify(item))
      await this.getNotWorkFixPhoto()
      this.isShowEditNotWorkDialog = true
    },
    async closeEditedNotWork () {
      this.isShowEditNotWorkDialog = false
      this.$nextTick(() => {
        this.editedNotWork = JSON.parse(JSON.stringify(this.defaultNotWork))
        this.editedNotWorkIndex = -1
      })
      await this.getNotWork()
    },
    async getNotWorkFixPhoto () {
      if (this.editedNotWork.FileNameList && this.editedNotWork.FileNameList.length > 0) {
        let response = await HttpFix.GetImage({
          fixNumber: this.editedNotWork.Number,
          fixFileList: this.editedNotWork.FileNameList.join(',')
        })
        this.notWorkFixImageList = response.status === 200 ? response.data.Data : []
      }
    },
    async getNotWork () {
      this.isNotWorkLoading = true
      let response = await HttpEngineerWork.GetNotWork({
        customerId: this.filterNotWork.CustomerId,
        licensePlate: this.filterNotWork.LicensePlate,
        mixNoticeFixType: this.filterNotWork.MixNoticeFixType,
        zoneType: this.filterNotWork.ZoneType,
        startTime: this.filterNotWork.StartTime,
        endTime: this.filterNotWork.EndTime,
        specialNeedId: this.filterNotWork.SpecialNeedId
      })
      this.notWorkList = response.status === 200 ? response.data.Data : []
      this.isNotWorkLoading = false
    },
    async isWork () {
      this.selected.forEach((element) => {
        element.MaintenanceEngineer = this.getUserAccountId
      })
      await HttpEngineerWork.UpdateIsWork(this.selected)
      await this.getNotWork()
    }
  }
}
</script>
